import FCharsDrog from './FCharsDrog.vue'

export default FCharsDrog